module.exports = __webpack_public_path__ + "img/flexed_biceps.58f01a54.gif";